export const ACTIVITY_TYPE_WEEKEND = 1
export const ACTIVITY_TYPE_HOLIDAY = 2
export const ACTIVITY_TYPE_SCORE = 3

export const ACTIVITY_TYPE_OPTIONS = [
  {
    value: ACTIVITY_TYPE_WEEKEND,
    label: '周末活动'
  },
  {
    value: ACTIVITY_TYPE_HOLIDAY,
    label: '节日活动'
  },
  {
    value: ACTIVITY_TYPE_SCORE,
    label: '评分活动'
  }
]

export const ACTIVITY_STATUS_OPTIONS = [
  {
    value: 1,
    label: '开启'
  },
  {
    value: 0,
    label: '关闭'
  }
]

export const MODULE_CONTENT_TYPE_OPTIONS = [
  {
    value: 1,
    label: '付费项'
  },
  {
    value: 2,
    label: '推荐剧'
  }
]

export const MODULE_RECOMMEND_TYPE_OPTIONS = [
  {
    value: 1,
    label: '系统推荐'
  },
  {
    value: 2,
    label: '指定剧集'
  }
]

const activityTypeLabelMap = ACTIVITY_TYPE_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.label
  return acc
}, {})

const activityStatusLabelMap = ACTIVITY_STATUS_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.label
  return acc
}, {})

const moduleContentTypeLabelMap = MODULE_CONTENT_TYPE_OPTIONS.reduce(
  (acc, item) => {
    acc[item.value] = item.label
    return acc
  },
  {}
)

export const getActivityTypeLabel = (value) =>
  activityTypeLabelMap[Number(value)] || '-'

export const getActivityStatusLabel = (value) =>
  activityStatusLabelMap[Number(value)] || '-'

export const getModuleContentTypeLabel = (value) =>
  moduleContentTypeLabelMap[Number(value)] || '-'
